import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { logUsage } from 'owa-analytics';

/**
 * Log telemetry data that are Reply All By Meeting specific
 */
export default function logReplyAllByMeetingMetricProperties(diffEvent: CalendarEvent) {
    const logData: { [key: string]: any } = {};

    logData.internetMessageId = diffEvent.InReplyTo;

    logUsage('CreateCalendarEventFromReplyAllWithMeeting', null /*Custom Data*/, {
        isCore: true,
        cosmosOnlyData: JSON.stringify(logData),
    });
}
